import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import OpeningTimesBlock from '@/components/Locations/subComponents/OpeningTimesBlock.vue';
import GoogleMapsNavigationButton from '@/components/Locations/subComponents/GoogleMapsNavigationButton.vue';
import Vue3Barcode from 'vue3-barcode';
import CheckoutSuccessThanks from '@/components/Red/RedCheckout/components/CheckoutSuccessThanks.vue';
export default defineComponent({
    name: 'red-checkout-success-content-store-payout',
    components: {
        CheckoutSuccessThanks,
        OpeningTimesBlock,
        Vue3Barcode,
        GoogleMapsNavigationButton,
    },
    props: {
        location: {
            type: Object,
            required: true,
        },
        order: {
            type: Object,
            required: true,
        },
        myschubert_url: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            downloadUrl: this.myschubert_url + '/api/local-store-payout/barcode-pdf/' + this.order.id,
        };
    },
    computed: Object.assign({}, mapGetters('account', {
        customerFirstName: 'firstName',
        customerEmail: 'email',
    })),
});
